import { c as _c } from "react/compiler-runtime";
import { DEFAULT_MARKUPS_SORT, parseMarkupsSort, stringifyMarkupsSort } from "@pages/project-details/project-markups/markups-toolbar/markups-sort-utils";
import { useSearchParams } from "react-router-dom";

/** Query param that stores the sort of the annotations, shared by all the views */
const SORT_QUERY_PARAM = "annotationsSort";

/** Returns the sort of the annotations, stored in the URL so it is kept when switching views */
export function useMarkupsSortQueryParam() {
  const $ = _c(7);
  const [searchParams, setSearchParams] = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = parseMarkupsSort(searchParams.get(SORT_QUERY_PARAM));
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sortItem = t0;
  let t1;
  if ($[2] !== setSearchParams) {
    t1 = function setSortItem(newSortItem) {
      const value = stringifyMarkupsSort(newSortItem);
      setSearchParams(params => {
        if (value === stringifyMarkupsSort(DEFAULT_MARKUPS_SORT)) {
          params.delete(SORT_QUERY_PARAM);
        } else {
          params.set(SORT_QUERY_PARAM, value);
        }
        return params;
      }, {
        replace: true
      });
    };
    $[2] = setSearchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setSortItem = t1;
  let t2;
  if ($[4] !== setSortItem || $[5] !== sortItem) {
    t2 = [sortItem, setSortItem];
    $[4] = setSortItem;
    $[5] = sortItem;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}